import { addMonths, format, isValid, parseISO } from 'date-fns';
import { ko } from 'date-fns/locale';

/** "2024. 03. 06 (수)" 형식 (Figma 예정 사용 일자) */
function formatWithWeekday(date: Date): string {
  return format(date, 'yyyy. MM. dd (eee)', { locale: ko });
}

export interface UsagePeriod {
  start: string;
  end: string;
}

/**
 * 예정 사용 일자 계산 — 서버 end_date 규칙 미러(start + term개월, 월말 보정은 addMonths가 처리).
 * startISO: 'YYYY-MM-DD'. 유효하지 않으면 빈 문자열.
 */
export function calculateUsagePeriod(
  startISO: string,
  termMonths: number,
): UsagePeriod {
  const start = parseISO(startISO);
  if (!isValid(start) || !Number.isFinite(termMonths) || termMonths < 1) {
    return { start: '', end: '' };
  }
  const end = addMonths(start, Math.floor(termMonths));
  return { start: formatWithWeekday(start), end: formatWithWeekday(end) };
}

/** "2024. 03. 06 (수) ~ 2024. 09. 06 (금)" — 없으면 빈 문자열. */
export function formatUsagePeriodRange(
  startISO: string,
  termMonths: number,
): string {
  const { start, end } = calculateUsagePeriod(startISO, termMonths);
  return start && end ? `${start} ~ ${end}` : '';
}
